import { render, staticRenderFns } from "./DataLoggerForm.vue?vue&type=template&id=54a70d66&scoped=true&"
import script from "./DataLoggerForm.vue?vue&type=script&lang=ts&"
export * from "./DataLoggerForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a70d66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
